import api from 'plugin/api';
import { API_URL } from 'types/const';
import format from 'utils/string/format';

/**
 * 사용자 목록 조회
 * @param {Object} [params] 요청 데이터
 * @param {number} [params.factoryCodeSeq] 담당 공장
 * @param {number} [params.haccpAuth] 결재권한
 * @param {string} [params.useYn] 사용유무
 * @param {string} [params.userId] ID
 * @param {string} [params.userNm] 담당자명
 * @param {number} [params.page=0] 페이지
 * @param {number} [params.size=20] 페이지당 최대 데이터 수
 * @return {Object} 응답 데이터
 */
async function requestList(params) {
  return api.get(API_URL.admin.list, { params });
}

/**
 * 사용자 등록
 * @param {Object} data 요청 데이터
 * @param {string} data.userId 아이디
 * @param {string} data.userNm 담당자 명
 * @param {string} data.buCode 소속 BU
 * @param {string} data.email 이메일
 * @param {number} data.factoryCodeSeq 기본 조회
 * @param {Object[]} data.authList 권한 목록
 * @param {string} data.authList[].pltCode 공장 코드
 * @param {string} data.authList[].pltCd 공장 코드 (SFSH)
 * @param {'Y' | 'N'} data.authList[].readYn 조회
 * @param {'Y' | 'N'} data.authList[].modYn 등록, 수정, 삭제
 * @param {'Y' | 'N'} data.haccpYn SFSH 사용자 여부
 * @return {Object} 응답 데이터
 */
async function requestInsert(data) {
  return api.post(API_URL.admin.insert, data);
}

/**
 * 사용자 수정
 * @param {number} seq 사용자 번호
 * @param {Object} data 요청 데이터
 * @param {string} data.userId 아이디
 * @param {string} data.userNm 담당자 명
 * @param {string} data.buCode 소속 BU
 * @param {string} data.email 이메일
 * @param {'Y' | 'N'} data.useYn 사용 여부
 * @param {number} data.factoryCodeSeq 기본 조회
 * @param {Object[]} data.authList 권한 목록
 * @param {string} data.authList[].pltCode 공장 코드
 * @param {string} data.authList[].pltCd 공장 코드 (SFSH)
 * @param {'Y' | 'N'} data.authList[].readYn 조회
 * @param {'Y' | 'N'} data.authList[].modYn 등록, 수정, 삭제
 * @param {'Y' | 'N'} data.haccpYn SFSH 사용자 여부
 * @return {Object} 응답 데이터
 */
async function requestUpdate(seq, data) {
  return api.put(format(API_URL.admin.inform, { seq }), data);
}

/**
 * 사용자 정보 조회
 * @param {number} seq 사용자 번호
 * @return {Object} 응답 데이터
 */
async function requestInform(seq) {
  return api.get(format(API_URL.admin.inform, { seq }));
}

/**
 * 사용자 중복 여부 조회
 * @param {Object} params 요청 데이터
 * @param {string} params.userId 아이디
 * @return {Object} 응답 데이터
 */
async function requestDuplicate(params) {
  return api.get(API_URL.admin.duplicate, { params });
}

export {
  requestList,
  requestInsert,
  requestUpdate,
  requestInform,
  requestDuplicate
};
